/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TypeContextVariable } from './TypeContextVariable';
import {
    TypeContextVariableFromJSON,
    TypeContextVariableFromJSONTyped,
    TypeContextVariableToJSON,
    TypeContextVariableToJSONTyped,
} from './TypeContextVariable';

/**
 * Rattache une variable à un objet en lui donnant une valeur. Une même variable ne peut être redéfinie qu'une fois par objet : le back refuse le doublon.
 * @export
 * @interface CreateVariableValueCommand
 */
export interface CreateVariableValueCommand {
    /**
     * Variable du référentiel (GET /expressions/variablesNoPagedResult).
     * @type {string}
     * @memberof CreateVariableValueCommand
     */
    variableId: string;
    /**
     * 
     * @type {number}
     * @memberof CreateVariableValueCommand
     */
    value: number;
    /**
     * Identifiant de l'objet porteur — le tunnel ici. Orthographe du back.
     * @type {string}
     * @memberof CreateVariableValueCommand
     */
    contextObjetId: string;
    /**
     * 
     * @type {TypeContextVariable}
     * @memberof CreateVariableValueCommand
     */
    typeContextVariable: TypeContextVariable;
    /**
     * Valeurs proposées au courtier, si la variable lui est réglable.
     * @type {string}
     * @memberof CreateVariableValueCommand
     */
    possibleValues?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateVariableValueCommand
     */
    isUserConfigurable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateVariableValueCommand
     */
    unite?: string | null;
}



/**
 * Check if a given object implements the CreateVariableValueCommand interface.
 */
export function instanceOfCreateVariableValueCommand(value: object): value is CreateVariableValueCommand {
    if (!('variableId' in value) || value['variableId'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('contextObjetId' in value) || value['contextObjetId'] === undefined) return false;
    if (!('typeContextVariable' in value) || value['typeContextVariable'] === undefined) return false;
    return true;
}

export function CreateVariableValueCommandFromJSON(json: any): CreateVariableValueCommand {
    return CreateVariableValueCommandFromJSONTyped(json, false);
}

export function CreateVariableValueCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateVariableValueCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'variableId': json['variableId'],
        'value': json['value'],
        'contextObjetId': json['contextObjetId'],
        'typeContextVariable': TypeContextVariableFromJSON(json['typeContextVariable']),
        'possibleValues': json['possibleValues'] == null ? undefined : json['possibleValues'],
        'isUserConfigurable': json['isUserConfigurable'] == null ? undefined : json['isUserConfigurable'],
        'unite': json['unite'] == null ? undefined : json['unite'],
    };
}

export function CreateVariableValueCommandToJSON(json: any): CreateVariableValueCommand {
    return CreateVariableValueCommandToJSONTyped(json, false);
}

export function CreateVariableValueCommandToJSONTyped(value?: CreateVariableValueCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'variableId': value['variableId'],
        'value': value['value'],
        'contextObjetId': value['contextObjetId'],
        'typeContextVariable': TypeContextVariableToJSON(value['typeContextVariable']),
        'possibleValues': value['possibleValues'],
        'isUserConfigurable': value['isUserConfigurable'],
        'unite': value['unite'],
    };
}

